import { NgModule } from '@angular/core';
import { UnescapeForwardSlashesPipe } from '@shared/pipes/unescape-forward-slashes/unescape-forwarwd-slashes.pipe';

@NgModule({
  declarations: [UnescapeForwardSlashesPipe],
  exports: [UnescapeForwardSlashesPipe],
})
export class UnescapeForwardSlashesModule {}
